import React from 'react';
import JobSearch from './components/job-search';
import JobResults from './components/job-results';
import JobDetails from './components/job-details';
import Provider from './components/jobs-wrapper';



function App() {
  

  return (
      
      <Provider>
        <JobSearch />      
        <section class="job_results bg-tan-light">
          <div class="container-xl">    
              <div class="row justify-content-center">
                {/*context.loading === true && (<JobResults />)*/}
                <JobResults />
                {(window.innerWidth >= 992) && <JobDetails />}
              </div>
          </div>
        </section>
      </Provider>
    
 
  );
}

export default App;
